import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8db6a866"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepDate" }
const _hoisted_2 = { class: "StepDate__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.stepNumber) + ". Укажите дату и период отправки", 1),
    (_ctx.opened)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mt-3",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createVNode(_component_the_input, {
            type: "date",
            value: _ctx.date,
            min: _ctx.min_date,
            max: _ctx.maxDate,
            placeholder: "Дата отправки",
            onChange: _ctx.onDateSelected
          }, null, 8, ["value", "min", "max", "onChange"]),
          _createVNode(_component_the_select, {
            class: "mt-3",
            disabled: !_ctx.date || !_ctx.state.is_period_check,
            placeholder: "Период отправки",
            value: _ctx.period,
            loading: _ctx.data_state.periods.is_loading,
            failed: _ctx.data_state.periods.is_failed,
            "error-text": "При получении списка периодов произошла ошибка",
            searchable: false,
            options: _ctx.getPeriods,
            onChange: _ctx.onPeriodSelected,
            onRefresh: _ctx.loadPeriods,
            label: "title"
          }, null, 8, ["disabled", "value", "loading", "failed", "options", "onChange", "onRefresh"]),
          _createVNode(_component_checkbox, {
            class: "mt-2",
            label: "Выбрать период отправки",
            value: _ctx.state.is_period_check,
            "onUpdate:value": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.is_period_check) = $event)),
              _ctx.onCheckboxChange
            ]
          }, null, 8, ["value", "onUpdate:value"])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}